import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

interface HubSpotConfig {
  onSuccess :(authCode :string) => void;
  onClose ?:() => void;
  onLoad ?:() => void;
  getAuthUrl :() => Promise<string>;
  channelId ?:number;
}

@Component({
  selector: 'lum-hubspot-connect-button',
  templateUrl: './hubspot-connect-button.component.html',
  styleUrls: ['./hubspot-connect-button.component.scss'],
})
export class HubSpotConnectButtonComponent implements OnInit {
  @Input()
  config :HubSpotConfig;

  @Input()
  disabled :boolean = false;

  @Output()
  onClick = new EventEmitter<void>();

  error :any;
  loading :boolean = false;

  constructor() {}

  ngOnInit() :void {
    // Initialization logic if needed
  }

  open() :void {
    if (this.error) {
      throw new Error(`Error with HubSpot connection: ${this.error}`);
    }

    if (!this.config?.getAuthUrl) {
      console.error('HubSpot configuration is missing getAuthUrl method');
      return;
    }

    this.loading = true;

    // Get the HubSpot authorization URL and open it
    this.config.getAuthUrl()
      .then((authUrl) => {
        this.loading = false;
        // Open the HubSpot OAuth URL in a new window
        window.open(authUrl, '_blank');
        
        // Call onLoad if provided
        if (this.config.onLoad) {
          this.config.onLoad();
        }
      })
      .catch((err) => {
        this.loading = false;
        this.error = err;
        console.error('Error getting HubSpot auth URL:', err);
      });
  }

  handleClick() :void {
    this.open();
  }
} 